import store from '@/state/store';

export default {
  install(app) {
    // Inject currentUser as a global property
    app.config.globalProperties.$currentUser = store.getters['auth/currentUser'];

    // Subscribe to store changes to keep the global property reactive
    store.subscribe(mutation => {
      if (mutation.type === 'auth/SET_CURRENT_USER') {
        app.config.globalProperties.$currentUser = store.getters['auth/currentUser'];
      }
    });
  },
};
